import type { BridgeExports } from "./bridge";
import type { BufferManagerExports } from "./buffers";
import type { ClientHostingExports } from "./clientHosting";
import type { CollaborationExports } from "./collaboration";
import type { ConnectorExports } from "./connector";
import type { DiagramPlayerExports } from "./diagramPlayer";
import type { DocumentExports } from "./document";
import type { EditorExports } from "./editor";
import type { FontLoadingExports } from "./fontLoading";
import type { GlobalCommandsExports } from "./globalCommands";
import type { HealthCheckExports } from "./healthCheck";
import type { HostingExports } from "./hosting";
import type { InteropExports } from "./interop";
import type { SmartLinkExports } from "./smartLink";
import type { TextEditorExports } from "./textEditor";
import { setup as setupBridge } from "./bridge";
import { setup as setupBuffers } from "./buffers";
import { setup as setupClientHosting } from "./clientHosting";
import { setup as setupCollaboration } from "./collaboration";
import { setup as setupConnector } from "./connector";
import { setup as setupDiagramPlayer } from "./diagramPlayer";
import { setup as setupDocument } from "./document";
import { setup as setupEditor } from "./editor";
import { setup as setupFontLoading } from "./fontLoading";
import { setup as setupGlobalCommands } from "./globalCommands";
import { setup as setupHealthCheck } from "./healthCheck";
import { setup as setupHosting } from "./hosting";
import { setup as setupInterop } from "./interop";
import { setup as setupSmartLink } from "./smartLink";
import { setup as setupTextEditor } from "./textEditor";

export type DotnetExports
  = BridgeExports
    & BufferManagerExports
    & ClientHostingExports
    & CollaborationExports
    & ConnectorExports
    & DocumentExports
    & EditorExports
    & FontLoadingExports
    & GlobalCommandsExports
    & HealthCheckExports
    & HostingExports
    & InteropExports
    & DiagramPlayerExports
    & SmartLinkExports
    & TextEditorExports
;

export function setupExports(exports: Partial<DotnetExports>) {
  setupBridge(exports.Bridge);
  setupBuffers(exports.Buffers);
  setupClientHosting(exports.ClientHosting);
  setupCollaboration(exports.Collaboration);
  setupConnector(exports.Connector);
  setupDocument(exports.Document);
  setupEditor(exports.Editor);
  setupFontLoading(exports.FontLoading);
  setupGlobalCommands(exports.GlobalCommands);
  setupHealthCheck(exports.HealthCheck);
  setupHosting(exports.Hosting);
  setupInterop(exports.Interop);
  setupDiagramPlayer(exports.DiagramPlayer);
  setupSmartLink(exports.SmartLink);
  setupTextEditor(exports.TextEditor);
}
